<template>
  <div id="select-dropdown">
    <b-dropdown v-bind:text="$t(value)" v-bind:variant="theme" v-bind:slot="this.position">
      <b-dropdown-item v-for="item in values" :key="item.id" @click="setSelected(item)">{{$t(item)}}</b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
export default {
  name: 'SelectDropdown',
  props: {
    options: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      required: false
    },
    position: {
      type: String,
      required: false
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    all: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      value: this.selected,
      values: this.options
    }
  },
  methods: {
    setSelected: function (val) {
      this.value = val
      if (this.value == 'all') {
        this.$emit('input', null)
      } else {
        this.$emit('input', this.value)
      }
    }
  },
  created () {
    if (this.all) {
      let newOptions = ['all']
      for (let i in this.options) {
        newOptions.push(this.options[i])
      }
      this.values = newOptions
    }
    if (this.selected == null && this.values.length > 0) {
      this.value = this.values[0]
    }
    if (this.position == null) {
      this.position = 'prepend'
    }
    if (this.value == 'all') {
      this.$emit('input', null)
    } else {
      this.$emit('input', this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/SelectDropdown.vue